import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AuthorizationButton = ({ doesNeedAuthorization, applicationName, onClick }) => {
  return (
    <Box sx={{ margin: '5px 0', padding: '10px', borderBottom: '1px solid #ccc' }}>
      <Box
        sx={{
          backgroundColor: '#fff3cd',
          color: '#856404',
          border: '1px solid #ffeeba',
          borderRadius: '4px',
          padding: '12px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        <FontAwesomeIcon icon={['fa', 'exclamation-triangle']} style={{ marginBottom: '8px', fontSize: '18px' }} />
        <Box sx={{ fontSize: '16px', marginBottom: '8px' }}>
          {doesNeedAuthorization ? (
            <Typography component='span'>
              🚨 Your <strong>{applicationName}</strong> account needs to be authorized for tax pro calls
            </Typography>
          ) : (
            <Typography component='span'>
              ✅ Your <strong>{applicationName}</strong> account is authorized for tax pro calls
            </Typography>
          )}
        </Box>
        <Button
          onClick={onClick}
          sx={{
            backgroundColor: doesNeedAuthorization ? '#dc3545' : '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '6px 12px',
            fontSize: '14px',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: doesNeedAuthorization ? '#c82333' : '#218838'
            }
          }}>
          {doesNeedAuthorization ? 'Authorize Account' : 'Reauthorize'}
        </Button>
      </Box>
    </Box>
  );
};
